package game.controller

import com.soywiz.korev.Key
import com.soywiz.korge.input.Input
import game.CgaColor
import game.Game
import view.CharMouseEvent
import view.Terminal

class MapController : GameController() {
    val mapBgColor = CgaColor.LIGHT_GRAY
    val mapRoomWidth = 8
    val mapRoomHeight = 4
    val mapColOffset = 4
    val mapRowOffset = 1
    var blinkTimer = 0

    override fun onActivate(game: Game) {
//        addButton()
    }

    override fun onTick(game: Game, input: Input) {
        if (
            input.keys.justPressed(Key.SPACE) ||
            input.keys.justPressed(Key.M) ||
            input.keys.justPressed(Key.ESCAPE)
        ) {
            game.controller = nextController
        }
    }

    override fun onRender(game: Game, terminal: Terminal) {
        terminal.fillRect(0, 0, 79, 24, 32, CgaColor.BLACK, mapBgColor)

        val level = game.currentRoom.level

        for (y in 0..5) {
            for (x in 0..8) {
                val col = x * mapRoomWidth + mapColOffset
                val row = y * mapRoomHeight + mapRowOffset

                val mapId = "L${level}R${x}${y}"

                val room = game.getRoomById(mapId)

                val lore = if (game.player.loreScanner && !game.isLoreDiscovered(room.id)) "L" else " "
                val item = if (game.player.itemScanner && room.itemUndiscovered(game)) "I" else " "
                val shardFound = if (room.discovered) room.getRemainingShards(game).toString().padStart(2, '0') else "??"
                val shardCount = if (room.discovered) room.shardCount.toString().padStart(2, '0') else "??"

                val shardMessage = "$item$lore$shardFound/$shardCount"

                val roomName = if (room.discovered == true) {
                    game.textOrNull("${mapId}_Name") ?: ""
                } else {
                    "???"
                }

                if (room != game.currentRoom || (blinkTimer / 10) % 2 == 0) {
                    terminal.drawText(
                        roomName,
                        col,
                        row,
                        col + mapRoomWidth,
                        1,
                        CgaColor.BLUE,
                        mapBgColor
                    )
                }

                terminal.drawString(
                    col,
                    row + 2,
//                    col + mapRoomWidth - 1,
                    shardMessage,
                    CgaColor.BLACK,
                    mapBgColor
                )

                terminal.drawSingleBorder(
                    col - 1,
                    row - 1,
                    col + mapRoomWidth - 1,
                    row + mapRoomHeight - 1,
                    CgaColor.DARK_GRAY,
                    mapBgColor
                )

                terminal.setChar(
                    col - 1,
                    row - 1,
                    0xC5,
                    CgaColor.DARK_GRAY,
                    mapBgColor
                )
            }
        }

        for (y in 1..5) {
            val leftCol = mapColOffset - 1
            val rightCol = mapColOffset + (mapRoomWidth * 9) - 1
            val row = y * mapRoomHeight + mapRowOffset - 1

            terminal.setChar(
                leftCol,
                row,
                0xC3,
                CgaColor.DARK_GRAY,
                mapBgColor
            )
            terminal.setChar(
                rightCol,
                row,
                0xB4,
                CgaColor.DARK_GRAY,
                mapBgColor
            )
        }

        for (x in 1..8) {
            val col = x * mapRoomWidth + mapColOffset - 1
            val topRow = mapRowOffset - 1
            val bottomRow = mapRoomHeight * 6 + mapRowOffset - 1

            terminal.setChar(
                col,
                topRow,
                0xC2,
                CgaColor.DARK_GRAY,
                mapBgColor
            )
            terminal.setChar(
                col,
                bottomRow,
                0xC1,
                CgaColor.DARK_GRAY,
                mapBgColor
            )
        }

        terminal.setChar(
            mapColOffset - 1,
            mapRowOffset - 1,
            0xDA,
            CgaColor.DARK_GRAY,
            mapBgColor
        )

        val levelName = game.text("Map_Level${game.currentRoom.level}")

        terminal.drawStringCentered(
            10,
            0,
            69,
            "[ $levelName ]",
            CgaColor.DARK_GRAY,
            mapBgColor,
            0xC4,
        )

        blinkTimer++
    }

    override fun onMouseDownChar(game: Game, event: CharMouseEvent) {
        game.controller = nextController
    }
}
